<svelte:options runes={false} />

<script>
  import SectionHeading from '../components/SectionHeading.svelte';

  export let payerLinkInput;
  export let onOpenPayerInvoice;
  export let onNavigateOperator;
</script>

<section class="panel payer-entry-panel">
  <SectionHeading eyebrow="Private payer access" title="" />
  <form class="payer-entry-form" on:submit|preventDefault={onOpenPayerInvoice}>
    <label>
      Invoice link or code
      <input
        bind:value={payerLinkInput}
        autocomplete="off"
        placeholder="Paste the invoice link or code"
      />
    </label>
    <button class="primary" type="submit">Open</button>
  </form>
  <p class="quiet">Invoices are only available through their shared links or exact id.</p>
  <div class="operator-entry">
    <span class="quiet">Are you the operator?</span>
    <button type="button" on:click={onNavigateOperator}>Operator sign in</button>
  </div>
</section>
